/* Black Friday Staffelrabatt – eine Logik für Produktseite, Kategorie, Warenkorb und die Bestätigung beim Stufenwechsel.
   Konfiguration kommt aus snippets/cx-staffel-config.liquid (window.cxStaffel), die Rabatte selbst sind automatische
   Rabatte in Shopify – die Leiste zeigt nur, wo der Kunde gerade steht. */
(function () {
  'use strict';
  var cfg = window.cxStaffel;
  if (!cfg || !Array.isArray(cfg.tiers) || !cfg.tiers.length) return;

  var tiers = cfg.tiers.slice().sort(function (a, b) { return a.min - b.min; });
  var subtotal = Number(cfg.subtotal) || 0;
  var STORE_KEY = 'cxst_tier';
  var VIP_COOKIE = 'cx_vip';
  var reduceMotion = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Pre-Sale nur per Link: ?vip=1 setzt ein Cookie, ohne Cookie bleibt alles unsichtbar ---------- */
  function readCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  }
  function vipAllowed() {
    if (!cfg.vipOnly) return true;
    var param = cfg.vipParam || 'vip';
    var url = new URL(location.href);
    if (url.searchParams.has(param)) {
      var days = Math.max(1, Number(cfg.vipDays) || 14);
      document.cookie = VIP_COOKIE + '=1; max-age=' + days * 86400 + '; path=/; SameSite=Lax; Secure';
      url.searchParams.delete(param);
      try { history.replaceState(history.state, '', url.toString()); } catch (e) {}
      return true;
    }
    return readCookie(VIP_COOKIE) === '1';
  }
  var vip = vipAllowed();
  if (!vip) return;

  /* Shopify merkt sich den Code aus dem Rabattlink selbst; falls er doch fehlt (Cookie abgelaufen, anderes Gerät),
     einmal pro Seite nachziehen – sonst zeigt die Leiste einen Rabatt, den der Warenkorb nicht hat. */
  function ensureVipCode(cart) {
    if (!cfg.vipOnly || !cfg.vipCode || !cart || !cart.item_count) return;
    var codes = (cart.discount_codes || []).map(function (c) { return String(c.code || '').toUpperCase(); });
    if (codes.indexOf(String(cfg.vipCode).toUpperCase()) !== -1) return;
    if (sessionStorage.getItem('cxst_code_tried') === '1') return;
    try { sessionStorage.setItem('cxst_code_tried', '1'); } catch (e) {}
    var root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
    fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: cfg.vipCode }) })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (updated) { if (updated) document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); })
      .catch(function () {});
  }

  var nf = {};
  function money(cents) {
    var whole = cents % 100 === 0;
    var key = whole ? 'w' : 'f';
    if (!nf[key]) {
      try {
        nf[key] = new Intl.NumberFormat(cfg.locale || 'de', { style: 'currency', currency: cfg.currency || 'EUR', minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2 });
      } catch (e) {
        nf[key] = { format: function (v) { return v.toFixed(whole ? 0 : 2) + ' €'; } };
      }
    }
    return nf[key].format(cents / 100);
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function tierIndex(sub) { var i = 0; for (var k = 0; k < tiers.length; k++) { if (sub >= tiers[k].min) i = k; } return i; }
  function tierTitle(t) { return t.percent + ' %' + (t.perk ? ' + ' + t.perk : ''); }
  function savings(sub, t) { return Math.round(sub * t.percent / 100); }

  /* ---------- Markup ---------- */
  function trackHtml(sub, idx) {
    var n = tiers.length, last = n - 1;
    var fill;
    if (idx >= last) fill = 100;
    else {
      var t = tiers[idx], next = tiers[idx + 1];
      var within = next.min > t.min ? Math.min(1, Math.max(0, (sub - t.min) / (next.min - t.min))) : 0;
      fill = ((idx + within) / last) * 100;
    }
    var nodes = tiers.map(function (t, i) {
      var cls = 'cxst__node' + (i <= idx ? ' is-done' : '') + (i === idx ? ' is-current' : '');
      var cap = i === 0 ? 'auf alles' : 'ab ' + money(t.min);
      return '<div class="' + cls + '" style="left:' + (i / last * 100) + '%">' +
        '<span class="cxst__dot">' + t.percent + '<small>%</small></span>' +
        '<span class="cxst__cap">' + esc(cap) + (t.perk ? '<em>' + esc(t.perk) + '</em>' : '') + '</span>' +
      '</div>';
    }).join('');
    return '<div class="cxst__track"><span class="cxst__fill" style="width:' + fill.toFixed(2) + '%"></span>' + nodes + '</div>';
  }

  function statusHtml(layout, sub, idx) {
    var t = tiers[idx], next = tiers[idx + 1];
    var head, sub2;
    if (layout === 'pdp') {
      head = 'Mit diesem Produkt: <b>' + t.percent + ' % Rabatt</b>' + (t.perk ? ' <b>+ ' + esc(t.perk) + '</b>' : '');
      sub2 = next ? 'Noch <b>' + money(next.min - sub) + '</b> bis ' + esc(tierTitle(next)) : 'Höchste Stufe – mehr geht nicht.';
    } else if (sub <= 0) {
      head = 'Ab dem ersten Artikel: <b>' + t.percent + ' % Rabatt</b> auf alles';
      sub2 = next ? 'Ab ' + money(next.min) + ' Warenwert: ' + esc(tierTitle(next)) : '';
    } else {
      head = 'Du sparst gerade <b>' + t.percent + ' %</b>' + (t.perk ? ' <b>+ ' + esc(t.perk) + '</b>' : '') + ' <span class="cxst__amount">(' + money(savings(sub, t)) + ')</span>';
      sub2 = next ? 'Noch <b>' + money(next.min - sub) + '</b> bis ' + esc(tierTitle(next)) : '<span class="cxst__max">Höchste Stufe erreicht</span>';
    }
    return '<p class="cxst__status">' + head + '</p>' + (sub2 ? '<p class="cxst__next">' + sub2 + '</p>' : '');
  }

  function fineHtml() {
    if (!cfg.fineprint) return '';
    return '<details class="cxst__fine"><summary>Bedingungen</summary><p>' + esc(cfg.fineprint) + '</p></details>';
  }

  function render(el) {
    var body = el.querySelector('[data-cxst-body]');
    if (!body) return;
    el.hidden = false;
    var layout = el.dataset.layout || 'cart';
    var add = layout === 'pdp' ? (Number(el.dataset.add) || 0) : 0;
    var sub = subtotal + add;
    var idx = tierIndex(sub);
    el.dataset.tier = idx;
    if (layout === 'collection') {
      // Kategorie: eine Statuszeile + die Stufen-Linie (wie Produktseite) – die Chip-Reihe wurde auf Mobil zu unruhig
      body.innerHTML = statusHtml('collection', sub, idx) + trackHtml(sub, idx);
    } else if (layout === 'pdp') {
      body.innerHTML = statusHtml('pdp', sub, idx) + trackHtml(sub, idx);
    } else {
      body.innerHTML = statusHtml('cart', sub, idx) + trackHtml(sub, idx) + fineHtml();
    }
    if (cfg.endLabel) {
      var claim = el.querySelector('.cxst__claim');
      if (claim && !claim.dataset.end) { claim.dataset.end = '1'; claim.textContent = (cfg.claim ? cfg.claim + ' ' : '') + 'Nur bis ' + cfg.endLabel; }
    }
  }

  function renderAll() { document.querySelectorAll('cx-staffel').forEach(render); }

  /* ---------- Bestätigung beim Erreichen einer Stufe ---------- */
  var toastTimer;
  function showToast(idx, sub) {
    if (!cfg.toast) return;
    var t = tiers[idx];
    var old = document.querySelector('.cxst-toast');
    if (old) old.remove();
    var el = document.createElement('div');
    el.className = 'cxst-toast';
    el.setAttribute('role', 'status');
    el.innerHTML = '<span class="cxst-toast__icon" aria-hidden="true"><svg viewBox="0 0 20 20" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M4 10.5l4 4 8-9"/></svg></span>' +
      '<span class="cxst-toast__text"><b>' + esc(tierTitle(t)) + '</b> freigeschaltet<small>Du sparst jetzt ' + esc(money(savings(sub, t))) + ' · ' + esc(cfg.label || 'Black Friday') + '</small></span>';
    el.addEventListener('click', function () { hideToast(el); });
    document.body.appendChild(el);
    requestAnimationFrame(function () { el.classList.add('is-in'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { hideToast(el); }, 5000);
  }
  function hideToast(el) {
    el.classList.remove('is-in');
    setTimeout(function () { el.remove(); }, reduceMotion ? 0 : 350);
  }
  function readStored() { try { var v = sessionStorage.getItem(STORE_KEY); return v == null ? null : Number(v); } catch (e) { return null; } }
  function store(idx) { try { sessionStorage.setItem(STORE_KEY, String(idx)); } catch (e) {} }
  function checkTierUp() {
    var idx = tierIndex(subtotal);
    var prev = readStored();
    if (prev != null && idx > prev && subtotal > 0) showToast(idx, subtotal);
    store(idx);
  }

  /* ---------- Element + Events ---------- */
  if (window.customElements && !customElements.get('cx-staffel')) {
    customElements.define('cx-staffel', class extends HTMLElement {
      connectedCallback() { render(this); }
    });
  } else {
    renderAll();
  }

  document.addEventListener('cart:change', function (e) {
    var cart = e.detail && e.detail.cart;
    if (!cart || typeof cart.items_subtotal_price !== 'number') return;
    subtotal = cart.items_subtotal_price;
    renderAll();
    checkTierUp();
  });

  document.addEventListener('variant:change', function (e) {
    var v = e.detail && e.detail.variant;
    var form = e.target;
    if (!v || !form) return;
    document.querySelectorAll('cx-staffel[data-layout="pdp"]').forEach(function (el) {
      if (el.dataset.form && form.id && el.dataset.form !== form.id) return;
      el.dataset.add = v.price || 0;
      render(el);
    });
  });

  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { subtotal = cart.items_subtotal_price || 0; renderAll(); store(tierIndex(subtotal)); })
      .catch(function () {});
  });

  function boot() {
    checkTierUp();
    if (cfg.vipOnly && cfg.vipCode) {
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(ensureVipCode)
        .catch(function () {});
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
